var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq"},[_c('Container',[_c('Card',{attrs:{"padding":"large"}},[_c('Margins',[_c('CardHeader',{attrs:{"header":_vm.$t('FAQ.TITLE')}}),_c('Accordion',{staticClass:"margins__triple",attrs:{"options":_vm.questions}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }